
import Loading from 'vux/src/components/loading/index.vue'
import Alert from 'vux/src/components/alert/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'

export default {
components: {Loading, Alert, XButton},
data () {
return {
show1: false,
text1: '请等待'
}
},
methods: {
showLoading () {
this.$vux.loading.show({
text: 'Loading'
})
setTimeout(() => {
this.$vux.loading.hide()
}, 2000)
}
}
}



// WEBPACK FOOTER //
// ./src/components/TestVux.vue